/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from '@reduxjs/toolkit';
import { ContentBlock, Stack, SecurityHelper } from 'sarsaparilla';
import { FacilityAlertBannerContainer } from 'shared-ui/containers/FacilityAlertBannerContainer';

import { FacilityProps, PassTypeProps } from '../../props';
import { isOffline } from '../../utils';
import Header from './Header';
import HeaderPlaceholder from '../HeaderPlaceholder';
import CTABar from './CTABar';
import Promo from './Promo';
import Content from './Content';

export class ActivityPassDetailsPage extends Component {
    static propTypes = {
        facility: FacilityProps,
        isLoading: PropTypes.bool,
        rating: PropTypes.object,
        passTypes: PropTypes.arrayOf(PassTypeProps),
        passTypesOffline: PropTypes.arrayOf(PassTypeProps),
        parentLocation: PropTypes.array,
        location: PropTypes.array,
    };

    render() {
        const {
            facility,
            isLoading,
            passTypes,
            rating,
            parentLocation,
            location,
            passTypesOffline,
        } = this.props;
        const facilityIsOffline = isOffline(passTypes);
        const isWidget = SecurityHelper.isWidgetSession();
        const passTypesOnline = passTypes.filter((item) => {
            return !item?.duration.endsWith('-offline');
        });
        const hideScanAndPayBannerForMixedPasses =
            passTypes?.length === 0 ||
            (passTypesOffline?.length === 0 && passTypesOnline?.length > 0) ||
            (facility?.hide_scan_and_pay_banner_for_mixed_passes &&
                passTypesOffline?.length > 0 &&
                passTypesOnline?.length > 0);

        if (isLoading) {
            return (
                <main className="ap-details-page">
                    <ContentBlock className="mt-5 mb-5">
                        <Stack>
                            <HeaderPlaceholder />
                        </Stack>
                    </ContentBlock>
                </main>
            );
        }

        return (
            <main className="ap-details-page">
                <FacilityAlertBannerContainer />
                <ContentBlock className="mt-5 mb-5">
                    <Stack>
                        {!hideScanAndPayBannerForMixedPasses && !isWidget && <Promo />}
                        {!isWidget && (
                            <Header
                                facility={facility}
                                parentLocation={parentLocation}
                                locationAsset={location}
                                rating={rating}
                            />
                        )}
                        {!facilityIsOffline && (
                            <CTABar facility={facility} passTypes={passTypes} />
                        )}
                        <Content
                            facility={facility}
                            passTypes={passTypes}
                            rating={rating}
                        />
                    </Stack>
                </ContentBlock>
            </main>
        );
    }
}

const mapStateToProps = (state) => ({
    rating: get(state, 'ratingReviews.fetchAggregate.data', {}),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ActivityPassDetailsPage);
